import React from "react";

const Loading = () => {
  return (
    <div className="flex flex-row place-content-center place-self-center w-full text-3xl font-bold text-[#2c2c75]">
      Loading...
    </div>
  );
};

export default Loading;
